module.exports = __webpack_public_path__ + "img/img1.018cfe29.png";